var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.loading
        ? _c("vue-loading", {
            attrs: {
              active: _vm.loading,
              "is-full-page": true,
              loader: "dots",
              color: "#70A1F0"
            },
            on: {
              "update:active": function($event) {
                _vm.loading = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "assets" },
        [
          _c(
            "div",
            { staticClass: "report" },
            [
              _c("vue-good-table", {
                attrs: {
                  columns: _vm.columns,
                  rows: _vm.filtered_assets,
                  "search-options": {
                    enabled: true,
                    skipDiacritics: true,
                    placeholder: "filter"
                  },
                  "pagination-options": {
                    enabled: true,
                    perPage: 50
                  },
                  styleClass: "vgt-table condensed"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", [
            _c("div", { staticClass: "panel" }, [
              _c("div", { staticClass: "heading" }, [
                _c("h4", [_vm._v("Assets")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "assets-download" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.downloadCSV()
                      }
                    }
                  },
                  [_vm._v("Download Report")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c(
                  "div",
                  { staticClass: "detail" },
                  _vm._l(_vm.all_services, function(service) {
                    return _c(
                      "div",
                      { key: service, staticClass: "services" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "service",
                            class: [
                              {
                                "active-service": _vm.selectedService == service
                              },
                              {
                                "hover-service":
                                  _vm.hoverService == service &&
                                  _vm.selectedService != service
                              },
                              {
                                "inactive-service":
                                  _vm.selectedService != service &&
                                  _vm.hoverService != service
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.setSelectedService(service)
                              },
                              mouseover: function($event) {
                                _vm.hoverService = service
                              },
                              mouseout: function($event) {
                                _vm.hoverService = null
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(service) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c571e686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c571e686","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Assets.vue
// module id = null
// module chunks = 